import { issueFormSource } from 'serviceWorker/services/issueForm/issueFormSource';
import type { ChannelUnsubscribe } from 'shared/channels';
import { issueFormContract } from 'shared/domain/issueForm/issueFormContract';
import { serveEntityRequests } from './serveEntityRequests';

/** Answers the issue form reads. */
export function serveIssueFormRequests(): ChannelUnsubscribe {
  return serveEntityRequests(issueFormContract, issueFormSource);
}
